module.exports = __webpack_public_path__ + "img/audio-player-bg.V0.1.0_202607150932.png";